import { useReducer, DispatchWithoutAction } from 'react'

export default function useForceReRender (): DispatchWithoutAction {
  // Use simple counter to trigger a render
  const [, forceReRender] = useReducer((x: number) => x + 1, 0)
  return forceReRender
};
